<template>
  <div>
    <el-row>
      <el-button type="primary" @click="onAddStudent">新增学生</el-button>
      <el-button type="primary" @click="onStudentExeal">模板下载</el-button>
      <el-button type="danger" @click="OpenResetPwd">重置密码</el-button>
      <el-button type="primary" @click="dialogVisibleImport = true"
        >导入学生信息</el-button
      >
      <el-button type="danger" @click="CalibrationTime">校对手环时间</el-button>
      <el-button
        type="danger"
        @click="batchRemove"
        :disabled="deleteList.length === 0"
        >批量删除</el-button
      >
    </el-row>
    <el-row style="margin-top: 20px" class="flex">
      <el-select
        v-if="userInfo.uID == 12"
        v-model="SchoolId"
        placeholder="请选择所属幼儿园"
        @visible-change="addonScrollData"
        style="margin-right: 20px"
      >
        <el-option
          v-for="item in addSchoolList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <div class="flex-items">
        <el-select
          style="margin-right: 20px"
          v-model="levelValueCopy"
          placeholder="请选择学届"
          @visible-change="GetStudyYearSelectResultCopy"
          @change="GetGradeListCopy"
        >
          <el-option
            v-for="item in levelListCopy"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex-items">
        <el-select
          style="margin-right: 20px"
          :popper-append-to-body="true"
          v-model="gradeValueCopy"
          placeholder="请选择年级"
          @change="onSelectGradeCopy"
        >
          <el-option
            v-for="item in gradeListCopy"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex-items">
        <el-select
          style="margin-right: 20px"
          v-model="classValueCopy"
          placeholder="请选择班级"
          @visible-change="GetClassSelectCopy"
          @change="onClassSelectCopy"
        >
          <el-option
            v-for="item in classListCopy"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
      </div>

      <el-input
        style="width: 300px; margin-right: 20px"
        v-model="LoginCode"
        placeholder="请输入账号"
      ></el-input>
      <el-input
        v-model="StudentName"
        placeholder="请输入姓名"
        style="width: 300px; margin-right: 20px"
      ></el-input>
      <el-button
        type="primary"
        @click="GetStudentByPage"
        style="margin-right: 20px"
        >查询</el-button
      >
      <el-button type="primary" @click="onClickEmpty" style="margin-right: 20px"
        >清空选项</el-button
      >
    </el-row>
    <el-table
      @current-change="selectCurrentRow"
      @selection-change="selsChange"
      :data="tableData"
      style="width: 100%; margin-top: 20px"
      :header-cell-style="{ background: '#F2F5FF', color: '#333' }"
      border
    >
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
        </template>
      </el-table-column>

      <el-table-column prop="StudentName" label="姓名" align="center">
      </el-table-column>
      <el-table-column prop="Sex" label="性别" align="center" width="50">
      </el-table-column>
      <el-table-column prop="StudyYearName" label="学届名称" align="center">
      </el-table-column>
      <el-table-column prop="GradeName" label="年级名称" align="center">
      </el-table-column>
      <el-table-column prop="ClassName" label="班级名称" align="center">
      </el-table-column>
      <el-table-column prop="BirthdayTimeString" label="生日" align="center">
      </el-table-column>
      <el-table-column prop="GradeName" label="所属年级" align="center">
      </el-table-column>
      <el-table-column prop="ClassName" label="所属班级" align="center">
      </el-table-column>
      <el-table-column prop="Phone" label="手机号" align="center">
      </el-table-column>
      <el-table-column prop="CreateTimeString" label="创建时间" align="center">
      </el-table-column>
      <el-table-column label="关联账号" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #4083fe"
            @click="onClickOpen(scope.row)"
            >{{ scope.row.UserId == 0 ? "绑定" : "查看" }}</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #4083fe"
            @click="onCLickOpenEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            style="color: #e14747"
            @click="onClickDelete(scope.row)"
            >删除</el-button
          >
          <el-button
            type="text"
            style="color: #e14747"
            @click="OpenBindMac(scope.row)"
            >绑定</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="PageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="PageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="text-align: center;padding:20px; 0 0 0"
    >
    </el-pagination>
    <!-- 查看账号 -->
    <el-dialog title="查看账号" :visible.sync="dialogVisibleBound" width="30%">
      <div>
        <el-table :data="BoundData" style="width: 100%">
          <el-table-column label="昵称" align="center">
            <template slot-scope="scope">
              {{ scope.row.userName ? scope.row.userName : "去绑定" }}
            </template>
          </el-table-column>
          <el-table-column label="账号" align="center">
            <template slot-scope="scope">
              {{ scope.row.code ? scope.row.code : "去绑定" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" @click="onClickBingd(scope.row)">{{
                scope.row.userId == 0 ? "绑定" : "重新绑定"
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 内层 -->
        <el-dialog
          width="30%"
          title="关联账号"
          :visible.sync="innerVisible"
          append-to-body
        >
          <div>
            <el-row class="flex">
              <el-col style="margin-right: 20px">
                <el-input
                  v-model="RealName"
                  placeholder="请输入昵称"
                ></el-input>
              </el-col>
              <el-col style="margin-right: 20px">
                <el-input
                  v-model="LoginName"
                  placeholder="请输入账号"
                ></el-input>
              </el-col>
              <el-col>
                <el-button type="primary" @click="GetUserBandList"
                  >查询</el-button
                >
              </el-col>
            </el-row>
            <el-table :data="relevanceData" style="width: 100%">
              <el-table-column prop="userName" label="昵称" align="center">
              </el-table-column>
              <el-table-column prop="code" label="账号" align="center">
              </el-table-column>
              <el-table-column
                v-if="userInfo.uID == 12"
                prop="schoolName"
                label="所属幼儿园"
                align="center"
              >
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    @click="onClickSearchBingd(scope.row)"
                    >{{
                      scope.row.userId == 0 ? "绑定" : "重新绑定"
                    }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-dialog>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBound = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleBound = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加/编辑 -->
    <el-dialog :title="Title" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio class="radio" :label="1">男</el-radio>
              <el-radio class="radio" :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="学届名称">
            <el-select
              v-model="ruleForm.studyYearId"
              placeholder="请选择学届"
              @visible-change="AddStudyYearSelectResult"
              @change="onSelectLevel"
            >
              <el-option
                v-for="item in addlevelList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年级名称">
            <el-select
              :popper-append-to-body="true"
              v-model="gradeValue"
              placeholder="请选择年级"
              @change="onSelectGrade"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级名称">
            <el-select
              v-model="classValue"
              placeholder="请选择班级"
              @change="onClassSelect"
            >
              <el-option
                v-for="item in classList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="出生日期" prop="date">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.date"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="所属幼儿园"
            prop="SchoolName"
            v-if="userInfo.uID == 12"
          >
            <el-select
              v-model="ruleForm.SchoolName"
              placeholder="请选择"
              @visible-change="addonScrollData"
            >
              <el-option
                v-for="item in addSchoolList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="Title == '新增学生' ? addSubmit() : editSubmit()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="学生导入" :visible.sync="dialogVisibleImport">
      <el-upload
        class="image-uploader"
        :multiple="false"
        :auto-upload="true"
        list-type="excel"
        :show-file-list="true"
        :drag="true"
        action
        :limit="1"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :http-request="uploadFile"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          一次只能上传一个文件，仅限excel格式，单文件不超过5MB
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleImport = false">取消</el-button>
        <el-button type="primary" @click="ImportStudent">提交</el-button>
      </div>
    </el-dialog>
    <!-- 重置密码 -->
    <el-dialog
      :visible.sync="dialogVisibleresetpwd"
      width="30%"
      title="重置密码"
    >
      <el-row class="flex-items">
        <el-col class="tui-border flex-center">
          <div style="width: 100px">新密码：</div>
          <el-input v-model="newpwd" placeholder="请输入新密码"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleresetpwd = false">取 消</el-button>
        <el-button type="primary" @click="ResetPwd">保存</el-button>
      </span>
    </el-dialog>

    <!-- 绑定手环 -->
    <el-dialog :visible.sync="dialogVisiblemqtt" width="30%" title="绑定手环">
      <el-row class="flex-items">
        <el-col class="tui-border flex-center">
          <div style="width: 100px">手环Mac：</div>
          <el-input v-model="bindmac.mac" placeholder="手环Mac："></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblemqtt = false">取 消</el-button>
        <el-button type="primary" @click="BindMac">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getAcademicSelect,
  GetGradeList,
  GetClassSelect,
  GetStudentByPage,
  GetStudent2User,
  GetUserBandList,
  StudentBandUser,
  GetSchoolList,
  Addf_studentinfo,
  Updatef_studentinfo,
  FileUploadsExcel,
  ImportStudent,
  GetStudentInfo,
  ResetUserPwd,
  DeleteStudentInfo,
  StuBindMacInfo,
  GetClassMacInfo,
} from "../../api/api";
import mqtt from "mqtt/dist/mqtt.min";

export default {
  data() {
    return {
      dialogVisiblemqtt: false,
      bindmac: {
        Mac: "",
        StudentId: 0,
      },
      client: {},
      ruleForm: {
        name: "",
        sex: 1,
        phone: "",
        date: new Date(),
        SchoolName: "",
        studyYearId: null,
      },
      addSchoolList: [],
      addlevelList: [],
      userInfo: {},
      levelList: [],
      levelListCopy: [],
      gradeList: [],
      gradeListCopy: [],
      classList: [],
      classListCopy: [],
      classValue: "",
      classValueCopy: "",
      gradeValue: "",
      gradeValueCopy: "",
      levelValue: null,
      levelValueCopy: null,
      PageIndex: 1,
      PageSize: 10,
      studyYearId: 0,
      gradeId: 0,
      classId: 0,
      total: 0,
      StudentName: "",
      LoginCode: "",
      tableData: [],
      BoundData: [],
      listId: 0,
      dialogVisibleBound: false,
      dialogVisibleImport: false,
      dialogVisibleresetpwd: false,
      newpwd: "",
      innerVisible: false,
      RealName: "",
      LoginName: "",
      relevanceData: [],
      dialogVisible: false,
      Title: "",
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        date: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        SchoolName: [
          { required: true, message: "请选择幼儿园", trigger: "change" },
        ],
      },
      excelurl: "",
      currentRow: null,
      SchoolId: null,
      addSchoolList: [],
      deleteList: [],
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.GetStudentByPage();
    this.mqttMsg();
  },
  destroyed() {
    if (client) {
      client.end(); //离开页面的时候  关闭mqtt连接
      client = null;
    }
  },
  methods: {
    async batchRemove() {
      this.$confirm("确认批量删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        DeleteStudentInfo({ Ids: this.deleteList.map((cc) => cc.Id) }).then(
          (res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.GetStudentByPage();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          }
        );
      });
    },
    mqttMsg() {
      var options = {
        //mqtt客户端的id
        username: "mqtt", //提取到配置文件
        password: "mqtt80313..++", //提取到配置文件
        clean: true,
        keepAlive: 60,
        clientId: "mqttjs_" + Math.random().toString(16).substr(2, 8),
        connectTimeout: 4000,
      };
      try {
        // mqtt连接
        this.client = mqtt.connect(
          "ws://mqtt.mushroomisland.cn:8083/mqtt",
          options
        );
      } catch (err) {
        console.log("err", err);
      }

      this.client.on("connect", (e) => {
        console.log("成功连接服务器:", e);
      });
      // 接收消息处理
      this.client.on("message", (topic, message) => {
        console.log("收到来自", topic, "的消息---->>", message.toString());
        this.mqMsg = message.toString();
      });
      // // 断开发起重连
      // this.client.on('reconnect', (error) => {
      //   console.log('正在重连:', error)
      // })
      // 链接异常处理
      this.client.on("error", (error) => {
        console.log("连接失败:", error);
      });
      //订阅
      //this.client.subscribe("/cmd/8EcRljwSIen/ec1b05b7099b/wristband/message/respond", { qos: Number(0) });
    },
    //绑定手环
    BindMac() {
      StuBindMacInfo(this.bindmac).then((res) => {
        console.log(res, "res");
        if (res.data.success) {
          this.$message({
            message: "绑定成功",
            type: "success",
          });
          this.dialogVisiblemqtt = false;
          let topic =
            "/cmd/8EcRljwSIen/" +
            res.data.response.BluetoothGatewayMAC + //班级网关Mac
            "/wristband/personal"; //和后台约定好的主题
          let message = res.data.response;
          message.class = res.data.response.ClassName;
          console.log(message, "message");
          this.client.publish(topic, JSON.stringify(message));
        } else {
          this.$message({
            message: "绑定失败！",
            type: "error",
          });
        }
      });
    },
    //校准时间
    CalibrationTime() {
      if (this.classValueCopy <= 0) {
        this.$message({
          message: "请先选择班级！",
          type: "error",
        });
        return;
      }
      GetClassMacInfo({ Id: this.classValueCopy }).then((res) => {
        if (res.data.success) {
          let topic =
            "/cmd/8EcRljwSIen/" +
            res.data.response + //班级网关Mac
            "/wristband/message"; //和后台约定好的主题
          let message = {
            type: "6",
            time: Math.round(new Date().getTime() / 1000).toString(),
          };
          this.client.publish(topic, JSON.stringify(message));
          this.$message({
            message: "校对成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "该班级暂未绑定网关！",
            type: "error",
          });
        }
      });
    },
    subscribe() {},
    OpenBindMac(row) {
      this.bindmac.StudentId = row.Id;
      this.dialogVisiblemqtt = true;
    },
    // 清空
    onClickEmpty() {
      this.levelValueCopy = null;
      this.levelListCopy = [];
      this.gradeValueCopy = null;
      this.gradeListCopy = [];
      this.classValueCopy = null;
      this.classListCopy = [];

      this.SchoolId = null;
      this.levelValue = null;
      this.StudentName = "";
      this.LoginCode = "";
      this.PageIndex = 1;
      this.GetStudentByPage();
    },
    async addonScrollData() {
      let res = await GetSchoolList();
      if (res.data.success) {
        this.addSchoolList = res.data.response;
      }
    },
    //显示重置密码界面
    OpenResetPwd() {
      if (this.sels == null || this.sels.length <= 0) {
        this.$message({
          message: "请选择用户！",
          type: "error",
        });
        return;
      }
      this.dialogVisibleresetpwd = true;
    },
    //重置密码
    ResetPwd() {
      var ids = this.sels.map((x) => x.SysUserId);
      if (ids.length <= 0) {
        this.$message({
          message: "请选择有效用户",
          type: "error",
        });
        return;
      }
      ResetUserPwd({ Ids: ids, PassWord: this.newpwd }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.dialogVisibleresetpwd = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    selsChange: function (sels) {
      //console.log(sels);
      this.sels = sels;
      this.deleteList = sels;
    },
    onStudentExeal() {
      location.href =
        "http://www.mushroomisland.cn/exceldown/%E8%98%91%E8%8F%87%E5%B2%9BV3%E5%B9%BC%E5%84%BF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";
    },
    //上传文件
    ImportStudent() {
      if (this.excelurl) {
        ImportStudent({
          fileName: this.excelurl,
          Uid: this.userInfo.uID,
          SchoolId: this.userInfo.SchoolId,
          UserName: this.userInfo.uRealName,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "成功",
              type: "success",
            });
            //初始化数据
            this.dialogVisibleImport = false;
            this.GetStudentByPage();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "请选择文件",
          type: "error",
        });
      }
    },
    //导入教师
    uploadFile(item) {
      //console.log(item);
      //    //console.log(this.comId);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      //    form.append("comId", this.comId);
      form.append("filetype", "excel");
      // //console.log(form);
      //debugger;
      FileUploadsExcel(form).then((res) => {
        this.excelurl = res.data.response;
        // //console.log(response);
        // //console.log(this.excelurl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    beforeUpload(file) {
      //console.log("beforeUpload");
      // //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      return isText | isTextComputer;
    },
    async addSubmit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (
            this.ruleForm.studyYearId &&
            this.gradeId != 0 &&
            this.classId != 0
          ) {
            let params = {
              Name: this.ruleForm.name,
              Sex: this.ruleForm.sex,
              Phone: this.ruleForm.phone,
              BirthdayTime: this.ruleForm.date,
              SchoolId:
                this.userInfo.uID == 12
                  ? this.ruleForm.SchoolName
                  : this.userInfo.SchoolId,
              SchoolType: 3,
              StudyYearId: this.ruleForm.studyYearId,
              gradeId: this.gradeId,
              classId: this.classId,
            };
            let res = await Addf_studentinfo(params);
            if (res.data.success) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              await this.setData();
              await this.GetStudentByPage();

              this.dialogVisible = false;
              this.$refs["ruleForm"].resetFields();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "请选择学届或者年级班级",
            });
          }
        }
      });
    },
    async editSubmit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let params = {
            id: this.ruleForm.Id,
            Name: this.ruleForm.name,
            Sex: this.ruleForm.sex,
            Phone: this.ruleForm.phone,
            BirthdayTime: new Date(this.ruleForm.date),
            SchoolId: this.ruleForm.SchoolName,
            StudyYearId: this.ruleForm.studyYearId,
            gradeId: this.gradeId,
            classId: this.classId,
          };
          let res = await Updatef_studentinfo(params);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            await this.setData();
            await this.GetStudentByPage();

            this.dialogVisible = false;
            this.$refs["ruleForm"].resetFields();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        }
      });
    },
    async setData() {
      this.ruleForm = {
        name: "",
        sex: 1,
        phone: "",
        date: new Date(),
        SchoolName: "",
        studyYearId: null,
      };
      this.classId = 0;
      this.gradeId = 0;
    },
    async addonScrollData() {
      let res = await GetSchoolList();
      if (res.data.success) {
        this.addSchoolList = res.data.response;
      }
    },
    // 删除幼儿
    onClickDelete(row) {
      this.$confirm("确认删除该幼儿吗?", "提示", {
        type: "warning",
      }).then(() => {
        DeleteStudentInfo({ Ids: [row.Id] }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.GetStudentByPage();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
    async onCLickOpenEdit(row) {
      this.Title = "编辑学生";
      await this.addonScrollData();
      await this.AddStudyYearSelectResult();

      let res = await GetStudentInfo({ Id: row.Id });
      if (res.data.success) {
        this.gradeValue = res.data.response.GradeId;
        this.classValue = res.data.response.ClassId;
        this.gradeId = res.data.response.GradeId;
        this.classId = res.data.response.ClassId;
        this.ruleForm = {
          Id: row.Id,
          name: row.StudentName,
          sex: row.SexType,
          phone: row.Phone,
          date: new Date(row.BirthdayTimeString),
          SchoolName: row.SchoolId,
          studyYearId: res.data.response.StudyYearId,
        };
        await this.GetGradeList();
        await this.GetClassSelect();
        this.dialogVisible = true;
      } else {
        this.$message({
          type: "error",
          message: "出错",
        });
      }

      //console.log(row);
    },
    onAddStudent() {
      this.Title = "新增学生";
      this.dialogVisible = true;
      // this.$refs["ruleForm"].resetFields();
    },
    async onClickSearchBingd(item) {
      let res = await StudentBandUser({ Id: this.listId, userId: item.userId });
      if (res.data.success) {
        this.innerVisible = false;
        this.dialogVisibleBound = false;
        this.$message({
          type: "success",
          message: "修改成功",
        });
      } else {
        this.innerVisible = false;
        this.dialogVisibleBound = false;
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    //   查看关联
    async onClickOpen(item) {
      this.BoundData = [];
      this.listId = item.Id;
      let res = await GetStudent2User({ Id: item.Id });
      if (res.data.success) {
        this.BoundData.push(res.data.response);
        this.dialogVisibleBound = true;
      } else {
        this.BoundData.push({
          code: "",
          userName: "",
          userId: 0,
          schoolName: null,
        });
        this.dialogVisibleBound = true;
      }
    },
    async onClickBingd(item) {
      this.innerVisible = true;
    },
    async GetUserBandList() {
      let res = await GetUserBandList({
        LoginName: this.LoginName,
        RealName: this.RealName,
      });
      if (res.data.success) {
        this.relevanceData = res.data.response;
      } else {
        this.relevanceData = [];
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetStudentByPage();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetStudentByPage();
    },
    async GetStudentByPage() {
      let params = {
        SchoolId:
          this.userInfo.uID == 12 ? this.SchoolId : this.userInfo.SchoolId,
        StudyYearId: this.levelValueCopy || 0,
        GradeId: this.gradeValueCopy || 0,
        ClassId: this.classValueCopy || 0,
        Uid: this.userInfo.uID,
        StudentName: this.StudentName,
        LoginCode: this.LoginCode,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      };
      let res = await GetStudentByPage(params);
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    //   学届下拉
    async GetStudyYearSelectResult() {
      let res = await getAcademicSelect({
        SchoolId: this.userInfo.SchoolId,
        Uid: this.userInfo.uID,
      });
      if (res.data.success) {
        this.levelList = res.data.response;
      }
    },
    //   学届下拉
    async GetStudyYearSelectResultCopy() {
      let res = await getAcademicSelect({
        SchoolId: this.userInfo.SchoolId,
        Uid: this.userInfo.uID,
      });
      if (res.data.success) {
        this.levelListCopy = res.data.response;
      }
    },
    //   学届下拉
    async AddStudyYearSelectResult() {
      let res = await getAcademicSelect({
        SchoolId: this.userInfo.SchoolId,
      });
      if (res.data.success) {
        this.addlevelList = res.data.response;
      }
    },
    // 年级下拉
    async GetGradeList() {
      let res = await GetGradeList({
        SchoolId: this.userInfo.SchoolId,
        studyYearId: this.ruleForm.studyYearId,
      });

      if (res.data.success) {
        this.gradeList = res.data.response;
      }
    },
    // 年级下拉
    async GetGradeListCopy() {
      let res = await GetGradeList({
        SchoolId: this.userInfo.SchoolId,
        studyYearId: this.levelValueCopy,
      });

      if (res.data.success) {
        this.gradeValueCopy = "";
        this.classValueCopy = "";
        this.classListCopy = [];
        this.gradeListCopy = res.data.response;
      }
    },
    // 班级
    async GetClassSelect() {
      if (this.gradeList.length != 0 || this.levelList.length != 0) {
        let params = {
          SchoolId: this.userInfo.SchoolId,
          studyYearId: this.ruleForm.studyYearId,
          gradeId: this.gradeId,
        };
        let res = await GetClassSelect(params);
        if (res.data.success) {
          this.classList = res.data.response;
        }
      }
    },
    async onSelectLevel(val) {
      this.PageIndex = 1;
      this.gradeValue = "";
      this.classValue = "";
      await this.GetGradeList();

      // await this.GetEvaluationList();
    },
    async onSelectLevelCopy(val) {
      this.PageIndex = 1;
      this.gradeValueCopy = "";
      this.classValueCopy = "";
      await this.GetGradeList();

      // await this.GetEvaluationList();
    },
    async onSelectGradeCopy(val) {
      this.PageIndex = 1;
      this.gradeValueCopy = val;
      await this.GetClassSelectCopy();
    },
    // 班级
    async GetClassSelectCopy() {
      console.log(this.gradeValueCopy, this.levelValueCopy);
      if (this.gradeValueCopy != "" && this.levelValueCopy) {
        let params = {
          SchoolId: this.userInfo.SchoolId,
          studyYearId: this.levelValueCopy,
          gradeId: this.gradeValueCopy,
        };
        let res = await GetClassSelect(params);
        if (res.data.success) {
          this.classListCopy = res.data.response;
        }
      }
    },
    async onSelectGrade(val) {
      this.PageIndex = 1;
      this.gradeId = val;
      await this.GetClassSelect();
      // await this.GetEvaluationList();
    },
    onClassSelect(val) {
      this.PageIndex = 1;
      this.classId = val;
      // this.GetEvaluationList();
    },
    onClassSelectCopy(val) {
      this.PageIndex = 1;
      this.classValueCopy = val;
      // this.GetEvaluationList();
    },
  },
};
</script>
<style lang="less" scoped>
</style>